import { z } from 'zod';

export const createSandboxSchema = z.object({
  game_code: z.string().min(1, { message: 'Game code is required' }),
  code: z
    .string()
    .min(1, { message: 'Code is required' })
    .max(64, { message: 'Code must be 64 characters or less' }),
  name: z.string().optional(),
  description: z
    .string()
    .min(1, { message: 'Description is required' })
    .max(1000, { message: 'Description must be 1000 characters or less' }),
  is_active: z.boolean(),
});

export type CreateSandbox = z.infer<typeof createSandboxSchema>;
